import React from "react";

const PageHero = ({ title, subtitle }) => (
  <section className="relative h-80 w-full bg-gradient-to-br from-[#E85D44] to-[#D44D34] overflow-hidden">
    <div className="max-w-screen-xl mx-auto px-6 h-full flex items-center justify-center relative z-10">
      <div className="text-center space-y-4">
        <p className="text-sm uppercase tracking-[0.3em] text-white/80">
          MERCH MASTERS LK
        </p>
        <h1 className="text-white text-5xl md:text-6xl font-bold leading-tight">{title}</h1>
        {subtitle && (
          <p className="text-white/90 text-lg max-w-2xl mx-auto">{subtitle}</p>
        )}
        <div className="w-24 h-0.5 bg-[#FFD93D] mx-auto"></div>
      </div>
    </div>
    {/* Decorative accent */}
    <div className="absolute bottom-0 left-0 right-0 h-2 bg-[#FFD93D]"></div>
  </section>
);

export default PageHero;